import { useEffect } from 'react';

const APP_NAME = 'Future Capability';

/**
 * Sets the browser tab title for the current page.
 * Automatically appends " | Future Capability" to the given title.
 * Resets to the app name on unmount.
 *
 * @param {string} title - The page-specific title (e.g. "Sign In")
 */
const useDocumentTitle = (title) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = prev;
    };
  }, [title]);
};

export default useDocumentTitle;
